const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Max Titanium",
    description: "900g",
    priceWithoutDiscount: "150.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_900g_max_titanium.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Integral medica",
    description: "900g Refil",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_integralmedica_907g-refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Iso blend",
    productBrand: "Synthe-Size",
    description: "907g",
    priceWithoutDiscount: "100.00",
    discountPrice: "95,99",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Whey/size_up_isolate_blend_protein_907g_refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Black-Skull",
    description: "900g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_900g_blackskull.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Isolate Protein",
    productBrand: "Profit",
    description: "900g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Whey/isolate_protein_mix_profit_lab_900g-refil.png"),
  },
];

export default ProducsData;
